import * as React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { __ } from '../../helpers/TranslationService';
import { RadioOnIcon } from '../Icons/newIcons/RadioOnIcon';
import { RadioOffIcon } from '../Icons/newIcons/RadioOffIcon';
import { eventTracker } from '../../helpers/EventTracker/EventTracker';
import { BreakpointsEnum } from '../../helpers/breakpoints';
import { ActionBarStyled } from '../ActionBar/ActionBar';
export interface IFlightSwitchProps {
    startHarbour: string;
    endHarbour: string;
    includesFlight: boolean;
    url: string;
    isDesktop?: boolean;
}

const FlightSwitchHeadline = styled.div`
    display: flex;
    width: 100%;
    justify-content: left;
    font-size: 16px;
    font-weight: 600;
    padding: 10px 0;
`;

const FlightSwitchRadioButtons = styled.div`
    display: flex;
    width: 100%;
    flex-flow: wrap;
`;

const FlightSwitchRadioButton = styled.link`
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    padding: 0 8px 0 0;
    @media (min-width: ${BreakpointsEnum.md}) {
        padding: 0 16px 0 0;
    }
    &:hover {
        text-decoration: none;
        color: ${({ theme }) => theme.text.color.primary};
    }
`;

const FlightSwitchRadioButtonText = styled.span`
    padding: 7px;
`;

const FlightSwitch = (props: IFlightSwitchProps) => {
    const { includesFlight, url } = props;
    const theme = useTheme();

    const clickHandler = () => {
        eventTracker.track({
            category: 'product page',
            action: 'flight switch',
            label: includesFlight ? 'with flight' : 'without flight',
        });
    };

    const style: Record<string, React.CSSProperties> = {
        RadioOnIcon: {
            fill: theme.colors.white[100],
            width: 20,
            height: 20,
            color: theme.actionBar.actionColor,
        },
        RadioOffIcon: {
            fill: theme.colors.white[100],
            color: theme.colors.iron[100],
            width: 20,
            height: 20,
        },
    };

    return (
        <ActionBarStyled>
            <FlightSwitchHeadline>{__('flightToDestination', 'dreamlines')}</FlightSwitchHeadline>
            <FlightSwitchRadioButtons>
                <FlightSwitchRadioButton
                    as={includesFlight ? 'a' : 'div'}
                    href={includesFlight ? url : null}
                    onClick={clickHandler}
                >
                    {includesFlight ? (
                        <RadioOffIcon style={style.RadioOffIcon} />
                    ) : (
                        <RadioOnIcon style={style.RadioOnIcon} />
                    )}
                    <FlightSwitchRadioButtonText>
                        {__('cruiseOnly', 'dreamlines')}
                    </FlightSwitchRadioButtonText>
                </FlightSwitchRadioButton>
                <FlightSwitchRadioButton
                    as={includesFlight ? 'div' : 'a'}
                    href={includesFlight ? null : url}
                    onClick={clickHandler}
                >
                    {includesFlight ? (
                        <RadioOnIcon style={style.RadioOnIcon} />
                    ) : (
                        <RadioOffIcon style={style.RadioOffIcon} />
                    )}

                    <FlightSwitchRadioButtonText>
                        {__('cruisePlusFlight', 'dreamlines')}
                    </FlightSwitchRadioButtonText>
                </FlightSwitchRadioButton>
            </FlightSwitchRadioButtons>
        </ActionBarStyled>
    );
};

export default FlightSwitch;
